$(document).ready(function(){


    const input = document.getElementById('custom_text');
    // const counter = document.getElementById('char-count');
  
    // input.addEventListener('input', () => {
    //     counter.textContent = `${input.value.length} / 10`;
      
    // });

    
  document.querySelectorAll('.custom_template_gf_angle').forEach(function (wrapper) {

    const input = wrapper.querySelector('#custom_text');
    const button = wrapper.querySelector('.product-form__submit');

    if (!input || !button) return;

    // Disable initially
    button.disabled = true;

    input.addEventListener('input', function () {
      if (this.value.trim().length > 0) {
        button.disabled = false;
      } else {
        button.disabled = true;
      }
    });

  });


})